<template>
    <v-row>
        <v-col cols="12" lg="8" order="12" order-lg="1">
            <v-card>
                <v-card-text>
                    <v-container>
                        <div>
                            <ProceduresToPay
                                v-if="cartStore.cartData != null"
                                :cart-procedures="cartStore.cartData.tramitesCarrito"
                                :get-procedure-all-items="showProcedureAllItems"
                                :move-to-cart ="moveToCart"
                                :move-to-wishlist="moveToWishlist"
                                :remove-procedure="requestRemoveItem"
                                type="cart"
                            />
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>

            <v-card class="mt-4" v-if="cartStore.cartData && cartStore.cartData.wishList && cartStore.cartData.wishList.length">
                <v-card-text>
                    <v-container>
                        <div>
                            <ProceduresToPay
                                v-if="cartStore.cartData != null"
                                :cart-procedures="cartStore.cartData.wishList"
                                :get-procedure-all-items="showProcedureAllItems"
                                :move-to-cart ="moveToCart"
                                :move-to-wishlist="moveToWishlist"
                                :remove-procedure="requestRemoveItem"
                                type="wishlist"
                            />
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>

            <DeleteDialog
                :show-modal="showDeleteDialog"
                :remove-item="removeItem"
                :cancel-remove-item="cancelRemoveItem"
            ></DeleteDialog>

        </v-col>
        <v-col  cols="12" lg="4" v-if="cartStore.cartData != null" order="1" order-lg="12">
            <Checkout
                :checkout-data="cartStore.cartData.tramitesCheckout"
                :checkout-total="cartStore.cartData.checkoutTotal"
                :checkout-items-number="countCheckoutItems"
                :submit-cart="submitCart1"
                :show-all-items="showCheckoutAllItems"
            ></Checkout>
        </v-col>
    </v-row>
  
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';

import ProceduresToPay from "./ProceduresToPay";
import DeleteDialog from "./DeteleDialog";
import Checkout from "@/components/Portfolio/Checkout";
import {cartBaseRequest, procedureAllItemsRequest, procedureMoveRequest} from "@/api/models";

export default {
    name: "Cart1",
    props: ['nextStep'],
    computed: {
        ...mapState({cartStore: state => state.cart}),
        ...mapGetters('cart', ['countCheckoutItems']),

        cssProps() {
            return {
                '--primary-color': this.$vuetify.theme.themes.light.primary
            }
        }
    },
    components: {
        ProceduresToPay, DeleteDialog, Checkout
    },

    data() {
        return {
            expand: [0],
            showDeleteDialog: false,
            procedureToRemoveId: 0,
        }
    },

    mounted() {
        this.initCartStep()
    },

    methods: {
        ...mapActions('cart', ['getCartStep1', 'getProcedureAllItems',
            'moveProcedureToCart', 'moveProcedureToWishlist', 'getCheckoutAllItems',
            'removeProcedureItem']),


        initCartStep(){
            this.getCartStep1()
        },

        moveToWishlist(procedureId){
            let request = procedureMoveRequest()
            request.cart_item_id = procedureId

            //Call to VueX
            this.moveProcedureToWishlist(request)
        },

        moveToCart(procedureId){
            let request = procedureMoveRequest()
            request.cart_item_id = procedureId

            //Call to VueX
            this.moveProcedureToCart(request)
        },

        showProcedureAllItems(procedureItemId, procedureIndex, procedureType){
            let request = procedureAllItemsRequest()
            request.cart_item_id = procedureItemId
            request.procedure_index = procedureIndex
            request.procedure_type = procedureType

            //Call to VueX
            this.getProcedureAllItems(request)
        },

        showCheckoutAllItems(){
            let request = cartBaseRequest()

            //Call to VueX
            this.getCheckoutAllItems(request)
        },

        requestRemoveItem(procedureItemId){
            this.procedureToRemoveId = procedureItemId
            this.showDeleteDialog = true
        },

        cancelRemoveItem(){
            this.procedureToRemoveId = 0
            this.showDeleteDialog = false
        },

        removeItem(){
            this.showDeleteDialog = false
            let request = procedureMoveRequest()
            request.cart_item_id = this.procedureToRemoveId

            //Call to VueX
            this.removeProcedureItem(request)
        },

        submitCart1(){
            let data = {tramites: []}
            this.cartStore.cartData.tramitesCarrito.forEach((item) => {
                data.tramites.push(item.tramiteCarritoId)
            })

            this.nextStep(1, data)
        },
    }
}
</script>

<style>
.v-expansion-panel .icon{
    order: 0;
}
.v-expansion-panel .header{
    order: 1;
}

.transaction-concepts > * {
    padding: 0px;
}

.transaction-concepts .v-data-table {
    background-color: transparent !important;
}
</style>